export const ProductName = "Dynamic Tech";
